import { useEffect, useState } from 'react'

import { Button } from '@material-ui/core'
import { Print, Refresh } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ContentWithOutSubTabs from 'Components/UI/Molecules/ContentWithOutSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import AddItem from './Add'
import { CajaFields } from './Fields'

const CajaData = ({ data, edit, setRender, render, setData, closeCancel, origen }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [formEdit, setFormEdit] = useState(data.cajas)
  // const [selectedRow, setSelectedRow] = useState(null)
  const createDismissableSnackbar = useCustomSnackbar()
  const [tab, setTab] = useState(0)

  const { state: receipt, setOpen: openReceipt, setClose: closeReceipt } = SetState()

  const { state: add, setOpen: openAdd, setClose: closeAdd } = SetState()

  const classes = useStyles()

  async function cajaInfo(id) {
    await interfaces.salesCaja.infoOneCaja(id, data.cajaInfo.origen).then((res) => {
      setData((prevData) => ({
        ...prevData,
        cajas: res.data.cajasInfo.sort((a, b) => a.id - b.id),
      }))
      setFormEdit(res.data.cajasInfo)
    })
  }

  useEffect(() => {
    const id = data.cajaInfo.id
    cajaInfo(id)
    // eslint-disable-next-line
  }, [formEdit?.length, data.cajaInfo.id])

  // const handleChange = (name, value) => {
  //   setData({
  //     ...data,
  //     receipt: {
  //       ...data.receipt,
  //       [name]: value,
  //     },
  //   })
  // }

  // const onClickRow = (index) => {
  //   if (!edit) return

  //   const selectedItem = formEdit.find((obj) => obj.id === index.id)

  //   setSelectedRow(selectedItem)
  //   setOpenPaymentDetail(true)
  // }

  // const editItem = async () => {
  //   if (!selectedRow.importe) {
  //     createDismissableSnackbar("El campos 'Importe' es obligatorio", {
  //       variant: 'error',
  //     })
  //     return
  //   }
  //   setIsLoading(true)
  //   const values = {
  //     id: selectedRow.id,
  //     empresa: empresaId,
  //     importe: Number(selectedRow.importe.replace(/[^0-9.,]+/g, '')),
  //     detalle: selectedRow.detalle,
  //     recibo: data.receipt.id,
  //     barcode: selectedRow.barcode,
  //     cupon: selectedRow.cupon,
  //     lote: selectedRow.lote,
  //     origen: selectedRow.origen,
  //     moneda: selectedRow.moneda,
  //   }

  //   await interfaces.salesOrders.editReceiptItem(values).then((res) => {
  //     const previousRow = formEdit.find((row) => row.id === selectedRow.id)
  //     const previousImporte = previousRow ? Number(previousRow.importe) : 0
  //     const importeDifference = values.importe - previousImporte
  //     const updatedRows = formEdit.map((row) =>
  //       row.id === selectedRow.id ? { ...row, importe: values.importe } : row
  //     )
  //     orderInfo(data.infoMain.id)
  //     setFormEdit(updatedRows)
  //     setData((prevData) => ({
  //       ...prevData,
  //       receiptDetails: updatedRows,
  //       receipt: {
  //         ...prevData.receipt,
  //         total: Math.trunc(prevData.receipt.total || 0) + Math.trunc(importeDifference),
  //         saldoResto: Math.trunc(prevData.receipt.saldoResto || 0) - Math.trunc(importeDifference),
  //       },
  //     }))
  //     createDismissableSnackbar(res.data, {
  //       variant: 'success',
  //     })
  //   })
  //   setClosePaymentDetail()
  //   setIsLoading(false)
  //   closeCancel()
  // }

  // const handleChangeItem = (name, value) => {
  //   setSelectedRow((prevInfo) => ({
  //     ...prevInfo,
  //     [name]: value,
  //   }))
  // }

  // async function print() {
  //   const values = {
  //     empresa: empresaId,
  //     pedido: data.infoMain.id,
  //   }
  //   setIsLoading(true)
  //   await interfaces.salesOrders
  //     .printReceipt(values)
  //     .then((res) => {
  //       printPDF(res, 500, 800).print()
  //       createDismissableSnackbar('Presupuesto impreso con éxito!', {
  //         variant: 'success',
  //       })
  //     })
  //     .catch(() => {
  //       createDismissableSnackbar('Algo salió mal', {
  //         variant: 'error',
  //       })
  //     })
  //   setIsLoading(false)
  // }

  const updateCaja = async () => {
    setIsLoading(true)
    const body = {
      empresa: data.cajaInfo.origen,
      id: data.cajaInfo.id,
    }
    await interfaces.salesCaja
      .updateCaja(body)
      .then((res) => {
        // setFormEdit((prevRows) => [...prevRows])
        // setData((prevData) => ({
        //   ...prevData,
        //   cajas: [...prevData.cajas, { ...info }],
        // }))
        setRender(!render)
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  const print = async () => {
    setIsLoading(true)
    const [dia, mes, año] = data.cajaInfo.fecha.split('/')
    const fechaFormateada = `${año}-${mes}-${dia}`
    const body = {
      empresa: data.cajaInfo.origen,
      sucursal: data.cajaInfo.sucursal,
      fecha: fechaFormateada,
    }
    await interfaces.salesCaja
      .print(body)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Caja impresa con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    closeCancel()
    setIsLoading(false)
  }

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <div style={{ margin: '2rem' }}>
              <InputsWithoutValidate
                key={data.cajaInfo ? data.cajaInfo.id : 'empty'}
                fields={CajaFields(data.cajaInfo, origen)}
                spacing={2}
                justifyContent="flex-start"
              />
            </div>

            <div
              style={{
                display: 'flex',
                margin: '2rem',
                cursor: edit ? 'pointer' : '',
                overflow: 'scroll',
              }}
            >
              <BasicTable
                col={[
                  { title: 'ID', style: { width: '25px' } },
                  { title: 'Tipo', style: { width: '50px' } },
                  { title: 'Efectivo', style: { width: '80px' } },
                  { title: 'Débitos', style: { width: '80px' } },
                  { title: 'Créditos', style: { width: '100px' } },
                  { title: 'Mercado pago', style: { width: '100px' } },
                  { title: 'Cheques', style: { width: '80px' } },
                  { title: 'Depósitos', style: { width: '80px' } },
                  { title: 'Transferencias', style: { width: '80px' } },
                  { title: 'Moneda extranjera', style: { width: '110px' } },
                ]}
                size="small"
                rows={formEdit?.map((row) => {
                  return {
                    id: row.id,
                    tipo: row.tipo === 1 ? 'Sistema' : 'Físico',
                    efectivo: `$${row.efectivo || ''}`,
                    debitos: `$${row.debito || ''}`,
                    creditos: `$${row.credito || ''}`,
                    mercado_pago: `$${row.mercadopago || ''}`,
                    cheques: `$${row.cheque || ''}`,
                    depositos: `$${row.deposito || ''}`,
                    transferencias: `$${row.transferencia || ''}`,
                    moneda_extranjera: `$${row.extranjera || ''}`,
                  }
                })}
                // onClickRow={permissions.allowEditMin ? () => {} : onClickRow}
              />
              <div>
                <div className={classes.buttonsHome}>
                  <Button
                    onClick={openReceipt}
                    disabled={data.recibos.length > 0 ? false : true}
                    variant="contained"
                    size="large"
                    style={{
                      marginLeft: '1rem',
                      height: '40px',
                      fontSize: 'inherit',
                      color: data.recibos.length > 0 ? '#3182a9' : '#7c7c7ce6',
                      backgroundColor: data.recibos.length > 0 ? '#d9edf7' : '#e0e0e0',
                      fontWeight: '600',
                      // fontSize: '1rem',
                    }}
                  >
                    Recibos
                  </Button>

                  <Button
                    onClick={openAdd}
                    disabled={!edit}
                    color="primary"
                    variant="contained"
                    size="large"
                    style={{
                      marginLeft: '1rem',
                      height: '40px',
                    }}
                  >
                    <AddIcon />
                  </Button>

                  <Button
                    onClick={print}
                    variant="contained"
                    size="large"
                    style={{
                      marginLeft: '1rem',
                      marginRight: '1rem',
                      height: '40px',
                    }}
                  >
                    <Print />
                  </Button>

                  <Button onClick={() => updateCaja()} variant="contained" size="large">
                    <Refresh />
                  </Button>
                </div>
              </div>
            </div>
          </>
        )
      default:
        break
    }
  }

  const renderDetails = () => {
    return (
      <div
        style={{ width: '45rem', display: 'flex', justifyContent: 'center', marginBottom: '20px' }}
      >
        <BasicTable
          col={[
            { title: 'Usuario', style: { width: '10px' } },
            { title: 'Razón social', style: { width: '80px' } },
            { title: 'Importe', style: { width: '70px' } },
          ]}
          size="small"
          rows={data.recibos.map((detalle) => {
            return {
              usuario: detalle.usuario,
              nombre: detalle.nombre,
              importe: `$${detalle.importe || ''}`,
            }
          })}
        />
      </div>
    )
  }

  return (
    <>
      <ContentWithOutSubTabs value={tab} setValue={setTab} children={renderTabs(tab)} />

      {add.suspense && (
        <AddItem
          open={openAdd}
          handleClose={closeAdd}
          render={render}
          setRender={setRender}
          dataInfo={data}
          setRows={setFormEdit}
          isLoading={isLoading}
        />
      )}

      {receipt.suspense && (
        <DialogComponent
          open={openReceipt}
          title="Recibos en estado borrador"
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          handleclose={closeReceipt}
          widthLarge="770px"
          children={renderDetails()}
        />
      )}

      {/* <DialogComponent
        open={paymentDetail.open}
        title="Editar medio de pago"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={
          selectedRow ? (
            <InputsWithoutValidate
              fields={editFields(selectedRow, handleChangeItem, dataBefore.data)}
              spacing={2}
            />
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={isLoading || isSubmitDisabled}
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={editItem}
            onClickCancel={setClosePaymentDetail}
          />
        }
      /> */}
    </>
  )
}

export default CajaData
